import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

const firstString = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return '';
  return String(arr[0] || '').trim();
};

/**
 * Transforms linkedin criteria.
 * Minimal output: Name + URL.
 *
 * @param {Object} linkedinCriteria - criteria.linkedin
 * @returns {Object} transformed criteria
 */
export const transformLinkedinAccount = (linkedinCriteria) => {
  if (!linkedinCriteria) {
    return {
      status: 'error',
      iconType: 'error',
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No LinkedIn Account was found.',
      data: null,
    };
  }

  const wooRankStatus = linkedinCriteria?.status || 'neutral';
  const importance = linkedinCriteria?.importance || 0;
  const solvability = linkedinCriteria?.solvability || 0;

  const name = String(linkedinCriteria?.data?.name || '').trim();
  const url = firstString(linkedinCriteria?.data?.urls);

  const isEmpty = !name && !url;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: isEmpty ? 'No LinkedIn Account was found.' : null,
    data: isEmpty ? null : { name, url },
  };
};

export default transformLinkedinAccount;


